












































import Component from 'vue-class-component'
import { AuthenticationModule } from '@/authentication/store/authentication-module'
import { Injector } from '@/config/dependency-injection'
import { Account } from '@/api/generated'
import { Watch } from 'vue-property-decorator'
import { RouterToken } from '@/config/injection-tokens'
import { VueRouter } from 'vue-router/types/router'
import Vue from 'vue'

@Component({
  props: {
    toggled: {
      type: Boolean,
    },
  },
})
export default class RespondecoMenu extends Vue {
  public isAbout = false
  public isVisible = false

  private authenticationModule: AuthenticationModule = Injector.get(AuthenticationModule)

  get activeUser(): Account {
    return this.authenticationModule.authenticatedUser
  }

  public mounted() {
    Injector.get<VueRouter>(RouterToken).beforeEach((to, from, next) => {
      if (to.name != null) {
        this.isAbout = to.name.indexOf('about-') > -1
      } else {
        this.isAbout = false
      }

      next()
    })
  }

  public hide() {
    this.$emit('hide')
  }

  @Watch('toggled')
  private onToggleChanged(visible: boolean) {
    this.isVisible = visible
  }
}
